var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7208 20.4891V20.2933C25.2875 18.3349 25.2875 15.5932 24.5042 13.6348C24.3083 14.614 23.9167 16.1807 22.7416 18.3349C21.9583 16.3765 20.7833 14.2223 19.9999 12.0681C19.2166 14.2223 18.0415 16.3765 17.2582 18.3349C16.0832 16.1807 15.6915 14.614 15.4957 13.6348C14.7123 15.5932 14.7123 18.3349 16.279 20.2933C16.4748 20.4891 16.279 20.4891 16.279 20.4891C15.4957 22.4475 13.3415 26.1684 12.5581 27.9309C12.9498 27.7351 13.5373 27.5392 13.929 27.3434C14.7123 26.9517 15.104 26.3642 15.4957 25.9725C16.279 24.6017 16.8665 23.8183 17.454 22.4475C18.2374 23.6225 19.2166 24.9934 19.9999 26.1684C20.7833 24.9934 21.7624 23.8183 22.5458 22.4475C23.1333 23.8183 23.525 24.6017 24.5042 25.9725C24.8958 26.3642 25.2875 26.9517 26.0709 27.3434C26.4625 27.5392 27.05 27.7351 27.4417 27.9309C26.6584 26.1684 24.5042 22.4475 23.7208 20.4891ZM19.9999 22.4475L18.6291 20.2933L19.9999 17.3557L21.3708 20.2933L19.9999 22.4475Z",
    fill: "url(#paint0_linear_908_186)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40L0 20L20 0L40 20L20 40ZM1.99003 20L20 38.01L38.01 20L20 1.99003L1.99003 20Z",
    fill: "url(#paint1_linear_908_186)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_186",
    x1: 12.0394,
    y1: -26.4557,
    x2: 5.42752,
    y2: -25.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_186",
    x1: -1.39409,
    y1: -97.1427,
    x2: -19.1268,
    y2: -94.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeg);
export default __webpack_public_path__ + "static/media/aeg.aad7c641ee5a1ed5101c4c1fbf4fc909.svg";
export { ForwardRef as ReactComponent };